import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FireflyBaseDraggableListComponent } from './base-draggable-list/base-draggable-list.component';

@Component({
  selector: 'f-draggable-list',
  templateUrl: './firefly-draggable-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireflyDraggableListComponent extends FireflyBaseDraggableListComponent {}
